import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgHotCocoa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 12.315h-2.615v1.713h2.616a2.288 2.288 0 012.283 2.292c0 .01-.081.998-.813 2.462l-.205.415c-.821 1.668-1.196 2.252-2.169 2.252h-1.712v1.712h1.712c2.126 0 2.929-1.63 3.705-3.208l.2-.405c.925-1.848.997-3.122.995-3.237a4.001 4.001 0 00-3.996-3.996z",
    fill: "#321717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.093 10.017a3.425 3.425 0 100-6.85 3.425 3.425 0 000 6.85z",
    fill: "#EDF1F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.374 8.875a3.14 3.14 0 100-6.28 3.14 3.14 0 000 6.28z",
    fill: "#EDF1F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79 8.302a2.411 2.411 0 100-4.823 2.411 2.411 0 000 4.823z",
    fill: "#EDF1F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.657 10.588a1.998 1.998 0 100-3.996 1.998 1.998 0 000 3.996zM4.617 7.834a1.194 1.194 0 100-2.388 1.194 1.194 0 000 2.388z",
    fill: "#EDF1F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.096 23.717v1.142c0 .63.512 1.141 1.142 1.141h11.988c.63 0 1.141-.511 1.141-1.142v-1.141H4.097z",
    fill: "#321717"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.359 7.74H4.126v15.965h14.233V7.74z",
    fill: "#622E04"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.359 7.74H4.126v4.542h14.233V7.74z",
    fill: "#E1D7D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#fff",
    d: "M4.125 7.74h14.233v.562H4.125z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.517 18.46a.737.737 0 100-1.474.737.737 0 000 1.474zM15.026 21.3a.856.856 0 100-1.713.856.856 0 000 1.712zM15.6 16.727a.477.477 0 100-.953.477.477 0 000 .953z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.747 12.04c.317-1.653.317-3.451-1.178-4.306.952-1.141 3.806-1.141 4.77 0-1.66.949-1.479 3.061-1.064 4.845.334.93.543 1.767.625 2.3l.002.02c.024.154.04.292.04.386a1.987 1.987 0 01-3.974 0c0-.086.013-.207.032-.342.08-.644.363-1.614.747-2.904z",
    fill: "#9C6131"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03 7.734a2.854 2.854 0 00-5.593 0h5.593z",
    fill: "#9C6131"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.342 7.734a1.427 1.427 0 10-2.796 0h2.796z",
    fill: "#9C6131"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8 2.739l3.738-1.397L21.626 0l-5.108 1.818-1.38 5.915h1.503L17.8 2.74z",
    fill: "#F8555B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.243 2.579l-1.25-.941.904-.32 1.213.936-.867.325zM20.317 1.838l-1.25-.942.904-.319 1.213.936-.867.325zM16.921 6.543l-1.625.52.188-.828 1.632-.559-.195.867zM17.452 4.246l-1.625.52.187-.828 1.633-.558-.195.866z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.198 4.333c.027 0 .053 0 .078.002.233.01.413.21.403.445a.425.425 0 01-.438.408c-.157-.005-.939.006-.986.731a.423.423 0 01-.45.397.425.425 0 01-.392-.454c.08-1.217 1.16-1.529 1.785-1.529zM14.598 4.731l.022.088a.493.493 0 01-.378.586.493.493 0 01-.59-.37c-.041-.177-.288-1.05-1.115-.885a.492.492 0 01-.581-.384.494.494 0 01.391-.578c1.39-.275 2.064.842 2.251 1.543z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.737 15.362a1.43 1.43 0 01-.015-.061.341.341 0 01.261-.405.34.34 0 01.408.255c.028.123.2.726.771.613a.34.34 0 01.402.265.341.341 0 01-.27.4c-.961.19-1.427-.583-1.557-1.067z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.824 7.327a.425.425 0 100-.85.425.425 0 000 .85z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.884 9.025l-.03-.079a.167.167 0 01.1-.213.177.177 0 01.228.104l.017.048c.235.635.7 1.886.226 3.424a.167.167 0 01-.223.104.177.177 0 01-.1-.217c.432-1.403.017-2.531-.218-3.17z",
    fill: "#fff"
  })));
}

export { SvgHotCocoa as default };